import React, { useEffect, useState, useCallback } from 'react';
import { Spin, message } from 'antd';
import { UpOutlined } from '@ant-design/icons';

import { Content } from './Content';
import { TituloCollapse } from './TituloCollapse';
import { ExtraCollapse } from './ExtraCollapse';

import api from '../../../../services/api';

import * as S from './styles';

const renderExpandIcon = ({ isActive }) => (
  <UpOutlined
    style={{
      fontSize: '18px',
      fontWeight: 'bold',
    }}
    rotate={isActive ? 0 : 180}
  />
);

export function CollapseCustom({
  data,
  existeDivergencia,
  setUpdateConsulta,
  updateConsulta,
  setChangeText,
  textAreaValue,
  carregarSolicitacaoAtual,
}) {
  const [tab, setTab] = useState('0');
  const [spinning, setSpinning] = useState(false);
  const [inconcistencias, setInconcistencias] = useState([]);

  const initialStateConsultasComRazoes = [
    ...new Set(
      data
        .flatMap(x => x.razoesReprovacaoConsulta)
        .filter(x => x.assinalado)
        .map(x => x.idConsultaSolicitacao)
    ),
  ];
  const [
    consultasComRazoesVinculadas,
    setConsultasComRazoesVinculadas,
  ] = useState(initialStateConsultasComRazoes ?? []);

  const callback = activeKeys => {
    const activeKey = Array.isArray(activeKeys) ? activeKeys[0] : activeKeys;
    setTab(activeKey === undefined ? '' : activeKey.toString());
  };

  const validarLista = useCallback(() => {
    const novaLista = data?.filter(
      item => item?.idStatus === 7 || item?.idStatus === 6
    );

    return setInconcistencias(novaLista);
  }, [data]);

  const compararlistas = (listaInconsistencias, listaData, id) => {
    const newItemList = listaInconsistencias?.filter(item => item?.id !== id);

    const newItemAlterado = listaData?.filter(item => item?.id === id);
    setInconcistencias([...newItemList, ...newItemAlterado]);
  };

  const aprovarConsulta = async id => {
    if (data.find(x => x.id === id).idStatus === 7) {
      await validacaoManualConsulta(id);
      return;
    }

    if (consultasComRazoesVinculadas.find(c => c === id)) {
      message.error(
        'Não foi possível aprovar a consulta, existem razões de reprovação adicionadas.'
      );
      return;
    }

    try {
      await api.put(`solicitacaoAtendimento/aprovarConsulta/${id}`);
      message.success('Consulta aprovada com sucesso.');
      setSpinning(false);
      compararlistas(inconcistencias, data, id);

      return data?.map(item => {
        if (item.id === id) {
          item.idStatus = 7;
        }
        setUpdateConsulta(!updateConsulta);
      });
    } catch (error) {
      message.error(
        error?.response?.data?.detail || 'Não foi possível aprovar a consulta.'
      );
      setSpinning(false);
    }
  };

  const reprovarConsulta = async id => {
    if (
      data?.find(x => x.id === id).razoesReprovacaoConsulta.length > 0 &&
      consultasComRazoesVinculadas.filter(c => c === id).length === 0
    ) {
      message.error(
        'Não foi possível reprovar a consulta, não existem razões de reprovação adicionadas.'
      );
      await validacaoManualConsulta(id);
      return;
    }
    setSpinning(true);
    try {
      await api.put(`solicitacaoAtendimento/ReprovarConsulta/${id}`);
      message.success('Consulta reprovada com sucesso.');
      setSpinning(false);
      compararlistas(inconcistencias, data, id);

      return data?.map(item => {
        if (item.id === id) {
          item.idStatus = 6;
        }
        setUpdateConsulta(!updateConsulta);
      });
    } catch (error) {
      message.error(
        error?.response?.data?.detail || 'Não foi possível reprovar a consulta.'
      );
    } finally {
      setSpinning(false);
    }
  };

  const validacaoManualConsulta = async id => {
    setSpinning(true);
    try {
      await api.put(`solicitacaoAtendimento/ValidacaoManualConsulta/${id}`);
      compararlistas(inconcistencias, data, id);

      return data?.map(item => {
        if (item.id === id) {
          if (item.descricaoStatus === 'Erro de Integração') {
            item.idStatus = 9;
          } else {
            item.idStatus = 8;
          }
        }
        setUpdateConsulta(!updateConsulta);
      });
    } catch (error) {
      message.error(
        error?.response?.data?.detail ||
          'Não foi possível voltar a consulta para validação manual.'
      );
    } finally {
      setSpinning(false);
    }
  };

  const adicionarDescricaoRazao = razoesReprovacao => {
    let descricao = '';
    razoesReprovacao.forEach(razao => {
      if (!textAreaValue || !textAreaValue.includes(razao.descricao)) {
        descricao += descricao.includes(razao.descricao)
          ? ''
          : `${razao.descricao}\n`;
      }
    });

    textAreaValue = textAreaValue
      ?.replace(/(\r\n|\r|\n){2}/g, '$1')
      .replace(/(\r\n|\r|\n){3,}/g, '$1\n');

    setChangeText(`${textAreaValue ?? ''}${descricao}`.trimStart());
  };

  const setRazoesConsultaSolicitacao = consulta => {
    const razoesVinculadas =
      data
        .flatMap(x => x?.razoesReprovacaoConsulta)
        .filter(x => x?.assinalado) ?? [];

    const razoesConsultasSolicitacoes = razoesVinculadas.filter(
      x => x.idConsultaSolicitacao === consulta?.id
    );

    return razoesConsultasSolicitacoes;
  };

  useEffect(() => {
    const validarReferencias = inconcistencias?.length === data?.length;
    existeDivergencia(validarReferencias);
  }, [inconcistencias, existeDivergencia, data]);

  useEffect(() => {
    validarLista();
  }, [validarLista, data]);

  useEffect(() => {
    const razoes = data
      .filter(x => x.razoesReprovacaoConsulta.length > 0)
      .flatMap(x => x.razoesReprovacaoConsulta)
      .filter(x => x.assinalado);
    adicionarDescricaoRazao(razoes);
  }, []);

  const collapseItems = data?.map((item, index) => {
    const panelKey = index.toString();
    const idEStatus = {
      id: item.id,
      status: item.idStatus,
    };

    return {
      key: panelKey,
      label: (
        <TituloCollapse
          origem={item?.nomeConsulta}
          idStatus={item.idStatus}
          setUpdateConsulta={setUpdateConsulta}
          updateConsulta={updateConsulta}
        />
      ),
      extra:
        tab === panelKey ? (
          <ExtraCollapse
            idEStatus={idEStatus}
            handlerAprovar={() => aprovarConsulta(idEStatus.id)}
            handlerReprovar={() => reprovarConsulta(idEStatus.id)}
          />
        ) : null,
      className: `site-collapse-custom-panel ${
        tab === panelKey ? 'open' : 'close'
      }`,
      children: (
        <Spin
          spinning={spinning}
          size="large"
          description="Carregando dados TmovGR!"
        >
          <Content
            data={item}
            setSpinning={setSpinning}
            setChangeText={setChangeText}
            textAreaValue={textAreaValue}
            adicionarDescricaoRazao={adicionarDescricaoRazao}
            consultasComRazoesVinculadas={consultasComRazoesVinculadas}
            setConsultasComRazoesVinculadas={setConsultasComRazoesVinculadas}
            razoesConsultaSolicitacao={setRazoesConsultaSolicitacao(item)}
            idEStatus={idEStatus}
            validacaoManualConsulta={validacaoManualConsulta}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
          />
        </Spin>
      ),
    };
  });

  return (
    <S.CollapsContainer
      ghost
      accordion
      activeKey={tab}
      onChange={callback}
      expandIconPlacement="end"
      expandIcon={renderExpandIcon}
      items={collapseItems}
    />
  );
}
